
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const ObraDam=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Obra Dam</h1>
           <p className="sub-heading">A marvel of engineering in Sonbhadra, offering scenic beauty and hydropower brilliance</p>
         </div>
         <div className="description">
         Obra Dam, situated in Sonbhadra, Uttar Pradesh, is a landmark built on the Rihand/Renuka River, featuring a rock-filled structure with an installed hydropower capacity of 99 MW. Located 11 km upstream of the confluence with the Son River, it provides irrigation and electricity to the region. The dam is surrounded by serene landscapes, making it an ideal spot for engineering enthusiasts and nature lovers to explore its significance and beauty.
         </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Obra Dam/dam1.jpeg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Obra Dam/dam2.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Obra Dam/dam3.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Obra Dam/dam4.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Obra Dam/dam5.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           
          
         </div>
   
         <BookSection />
       </div>
     );
};